/* unplugin-vue-components disabled */import script from "./admin-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-layout.vue?vue&type=script&setup=true&lang=js"

import "./admin-layout.vue?vue&type=style&index=0&id=4a8504a3&lang=less&scoped=true"
import "./admin-layout.vue?vue&type=style&index=1&id=4a8504a3&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a8504a3"]])

export default __exports__